<div #mapViewEl class="map-view"></div>

<div class="logo-container" #logoContainerEl [hidden]="!showLogo">
  <img *ngIf="!!showLogo" class="logo" src="assets/logo-anacom-white.svg" />
</div>

<div
  class="menu-container"
  #menuButtonEl
  [hidden]="!showMenuButton"
  (click)="onBtnMenuToggleClick()"
>
  <img *ngIf="showMenuButton" src="assets/icons/menu.svg" />
</div>

<div
  class="toc-button"
  #tocButtonEl
  [hidden]="!isMobileScreen"
  (click)="handleTocModal()"
>
  <img *ngIf="isMobileScreen" src="assets/icons/toc-button.svg" />
</div>

<div
  *ngIf="appConfig.externalMode"
  #translationButtonEl
  class="translation-button"
>
  <app-translation-button />
</div>

<div #topRightFirstLineEl class="custom-widget-component">
  <app-address-search-bar
    *ngIf="!!mapConfigured"
    (onItemChange)="onAddressLocationChange($event)"
  ></app-address-search-bar>
</div>

<div #scaleInfoEl class="custom-widget-component"></div>

<div #scaleBarEl class="custom-widget-component">
  <app-scale-bar
    *ngIf="
      !isMobileScreen && !!mapConfigured && isWidgetActive(widgetTypes.Scales)
    "
    [mapView]="mapView"
  ></app-scale-bar>
</div>

<div #projectionEl class="custom-widget-component">
  <app-projection
    *ngIf="
      !isMobileScreen && !!mapConfigured && isWidgetActive(widgetTypes.Coords)
    "
    [mapView]="mapView"
  ></app-projection>
</div>

<div #projectionLabelEl class="custom-widget-component">
  <app-projection-label
    *ngIf="
      !isMobileScreen && !!mapConfigured && isWidgetActive(widgetTypes.Coords)
    "
    [mapView]="mapView"
  ></app-projection-label>
</div>

<div #overviewMapEl class="custom-widget-component">
  <app-overview-map
    class="overview-map"
    *ngIf="!!mapConfigured && isWidgetActive(widgetTypes.Overview)"
    [mapView]="mapView"
  ></app-overview-map>
</div>

<div #compassEl title="Orientação do mapa a norte"></div>

<div
  #floatingFilterContainerEl
  class="custom-widget-component floating-filter-container"
></div>

<div #mapToolList class="tool-list-container">
  <app-map-tool-list *ngIf="!!mapConfigured"></app-map-tool-list>
</div>

<div *ngIf="appConfig.siiaMode" #popupSiiaDocumentsEl class="popup-attachments">
  <ng-container *ngIf="!!attachmentList?.length">
    <div class="attachment-item" *ngFor="let item of attachmentList">
      <div class="text">
        {{ item.text }}
      </div>

      <div class="icon">
        <a [href]="item.url" target="_blank">
          <app-iconic class="icon" icon="assets/icons/link.svg"></app-iconic>
        </a>
      </div>
    </div>
  </ng-container>
</div>

<div class="widget-modal-list-container" #widgetModalListContainerEl>
  <ng-container *ngIf="!!mapConfigured">
    <ng-container [ngSwitch]="!!isMobileScreen">
      <ng-container *ngSwitchCase="false">
        <app-modal
          *ngFor="let item of widgetModalItemList"
          [(visible)]="item.visible"
          (onShowing)="item.loaded = true"
          (onShown)="item.loaded = true"
          (onHidden)="onWidgetModalHidden(item)"
          [modalTitle]="item.title | uppercase"
          modalTitleLocation="before"
          [container]="widgetModalListContainerEl"
          [closeBtnEnabled]="true"
          [closeOutsideClickEnabled]="false"
          [bringToFrontOnClickEnabled]="true"
          [minimizeBtnEnabled]="true"
          [draggableEnabled]="true"
          [useHeaderAsDragHandle]="true"
          [useBodyAsDragHandle]="true"
          [restrictDraggingToContainer]="
            item.restrictDraggingToContainerObservable | async
          "
          modalVerticalAlignment="top"
          containerVerticalAlignment="top"
          modalHorizontalAlignment="left"
          containerHorizontalAlignment="left"
          [posY]="15"
          [posX]="192"
          [(minimized)]="item.minimized"
          [scrollEnabled]="false"
          [overlayMask]="false"
          [width]="item.width"
          [height]="item.height"
          [maxHeight]="item.maxHeight"
        >
          <ng-template modalContent>
            <ng-container
              [ngTemplateOutlet]="item.template"
              [ngTemplateOutletContext]="item.data"
            ></ng-container>
          </ng-template>
        </app-modal>
      </ng-container>

      <ng-container *ngSwitchCase="true">
        <app-bottom-sheet
          *ngFor="let item of widgetModalItemList"
          [(opened)]="item.visible"
          (onClosed)="onWidgetModalHidden(item)"
          [container]="widgetModalListContainerEl"
          [height]="
            !item.height || item.height === 'auto'
              ? 'auto'
              : 'calc(' + item.height + ' + 3rem' + ')'
          "
          maxHeight="50vh"
          sheetTitle="{{ item.title | uppercase }}"
          [showHeaderDivider]="true"
          [overlayMask]="false"
        >
          <ng-template bottomSheetContent>
            <ng-container
              [ngTemplateOutlet]="item.template"
              [ngTemplateOutletContext]="item.data"
            ></ng-container>
          </ng-template>
        </app-bottom-sheet>
      </ng-container>
    </ng-container>
  </ng-container>
</div>

<ng-template #searchByDrawingTpl>
  <app-influence-area
    [mapView]="mapView"
    [searchGroupLayer]="searchGroupLayer"
    (onGeometryChanged)="onSearchByGeometry($event)"
  ></app-influence-area>
</ng-template>

<ng-template #searchResultsTpl let-minimizeWidget="minimizeWidget">
  <app-search-results
    [mapView]="mapView"
    [mainMapImageLayer]="mainMapImageLayer"
    [geometryToSearch]="geometryToSearch"
    [floatingFilterContainer]="floatingFilterContainerEl"
    (onFilterOnMapClick)="minimizeWidget(); onFilterOnMapClick()"
    (onGraphicZoomed)="minimizeWidget()"
    (onClearClick)="onResultClearClick()"
  ></app-search-results>
</ng-template>

<ng-template #searchResultsInternalTpl>
  <app-search-results-internal
    [mapView]="mapView"
    [geometryToSearch]="geometryToSearch"
  ></app-search-results-internal>
</ng-template>

<ng-template #loadDataFormTpl>
  <app-load-data-form></app-load-data-form>
</ng-template>

<ng-template #addLayersFormTpl>
  <app-add-layers-form
    [mapView]="mapView"
    [groupLayer]="additionalGroupLayer"
  ></app-add-layers-form>
</ng-template>

<ng-template
  #quotaInfoTpl
  let-config="config"
  let-columnAlias="columnAlias"
  let-initialMsg="initialMsg"
>
  <app-quota-info
    [mapView]="mapView"
    [quotaGroupLayer]="quotaGroupLayer"
    [config]="config"
    [initialMsg]="initialMsg"
    [columnAlias]="columnAlias"
  ></app-quota-info>
</ng-template>

<ng-template #heatmapLayersTpl>
  <app-heatmap-layers
    [mapView]="mapView"
    [manipulationGroupLayer]="manipulationGroupLayer"
  ></app-heatmap-layers>
</ng-template>

<ng-template #clusterLayersTpl>
  <app-cluster-layers
    [mapView]="mapView"
    [manipulationGroupLayer]="manipulationGroupLayer"
  ></app-cluster-layers>
</ng-template>

<ng-template #measurementTpl>
  <app-measurement
    [mapView]="mapView"
    [measurementGroupLayer]="measurementGroupLayer"
  ></app-measurement>
</ng-template>

<ng-template #registerElementMapTpl let-closeWidget="closeWidget">
  <app-register-element-map
    [mapView]="mapView"
    [mainImageLayer]="mainMapImageLayer"
    [(graphicToEdit)]="registerElementGraphicToEdit"
    (onRegisterSaved)="closeWidget()"
  ></app-register-element-map>
</ng-template>

<ng-template #registerEventTpl let-closeWidget="closeWidget">
  <app-events-register
    [mapView]="mapView"
    [mainMapImageLayer]="mainMapImageLayer"
    (onSaved)="closeWidget()"
  ></app-events-register>
</ng-template>

<ng-template #convertCoordinatesTpl>
  <app-convert-coordinates
    [mapView]="mapView"
    [graphicsLayer]="convertCoordinatesLayer"
  ></app-convert-coordinates>
</ng-template>

<ng-template #mapManagementTpl let-minimizeWidget="minimizeWidget">
  <app-maps-management (onMapLoaded)="minimizeWidget()"></app-maps-management>
</ng-template>

<ng-template #calcPathTpl>
  <app-calc-path [mapView]="mapView"></app-calc-path>
</ng-template>

<ng-template #printMapTpl>
  <app-print-map-form [mapView]="mapView"></app-print-map-form>
</ng-template>

<ng-template #occurrencesManagementTpl>
  <app-occurrences-management
    [mapView]="mapView"
    [mainMapImageLayer]="mainMapImageLayer"
    [groupLayer]="searchGroupLayer"
  ></app-occurrences-management>
</ng-template>

<ng-template #searchAnnouncementTpl>
  <app-search-announcement></app-search-announcement>
</ng-template>

<ng-template #identifyTpl>
  <app-identify [mapView]="mapView" [point]="identifyPoint"></app-identify>
</ng-template>

<ng-template #notesTpl>
  <app-notes
    [mapView]="mapView"
    [drawNoteGraphicsLayer]="notesGraphicsLayer"
  ></app-notes>
</ng-template>

<ng-template #helpTpl>
  <app-help></app-help>
</ng-template>

<ng-template #availableCoverageTpl>
  <app-available-coverage></app-available-coverage>
</ng-template>

<app-share-map-link-modal
  *ngIf="shareLinkModalVisibleObservable | async"
  [visible]="shareLinkModalVisibleObservable | async"
></app-share-map-link-modal>

<app-toc
  *ngIf="!!mapConfigured"
  [container]="widgetModalListContainerEl"
  [mapView]="mapView"
></app-toc>

<app-splash-modal *ngIf="!!!appConfig.siiaMode"></app-splash-modal>
